export var FOCUSABLE_ELEMENTS = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
export var returnFocusToActivator = activator => {
  if (typeof (activator === null || activator === void 0 ? void 0 : activator.focus) === 'function') {
    activator.focus();
  }
};
export var setFocus = (modalRef, _ref, firstElementRef) => {
  var _ref2, _body$querySelector;
  var {
    body: BODY_CLASSNAME,
    footer: FOOTER_CLASSNAME,
    header: HEADER_CLASSNAME
  } = _ref;
  if (firstElementRef !== null && firstElementRef !== void 0 && firstElementRef.current) {
    firstElementRef.current.focus();
    return;
  }
  if (!modalRef.current) {
    return;
  }
  var body = modalRef.current.querySelector(".".concat(BODY_CLASSNAME));
  var footer = modalRef.current.querySelector(".".concat(FOOTER_CLASSNAME));
  var header = modalRef.current.querySelector(".".concat(HEADER_CLASSNAME));
  var firstFocusableElement = (_ref2 = (_body$querySelector = body === null || body === void 0 ? void 0 : body.querySelector(FOCUSABLE_ELEMENTS)) !== null && _body$querySelector !== void 0 ? _body$querySelector : footer === null || footer === void 0 ? void 0 : footer.querySelector(FOCUSABLE_ELEMENTS)) !== null && _ref2 !== void 0 ? _ref2 : header === null || header === void 0 ? void 0 : header.querySelector(FOCUSABLE_ELEMENTS);
  firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
};
export var trapFocus = (event, modalRef) => {
  if (!modalRef.current || event.key !== 'Tab') return;
  var focusable = modalRef.current.querySelectorAll(FOCUSABLE_ELEMENTS);
  var firstFocusable = focusable[0];
  var lastFocusable = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === firstFocusable) {
    event.preventDefault();
    lastFocusable.focus();
  }
  if (!event.shiftKey && document.activeElement === lastFocusable) {
    event.preventDefault();
    firstFocusable.focus();
  }
};
export var closeOnEscape = (event, close) => {
  if (event.key === 'Escape') close();
};